import {Root, Thumb} from '@radix-ui/react-switch';
import clsx from 'clsx';

import type {SwitchProps} from '@radix-ui/react-switch';

export function Switch({
  ref: forwardedRef,
  className,
  ...props
}: SwitchProps & React.RefAttributes<HTMLButtonElement>): React.JSX.Element {
  return (
    <Root
      {...props}
      ref={forwardedRef}
      className={clsx(
        className,
        'flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-blue10 disabled:cursor-not-allowed disabled:opacity-50 radix-state-checked:bg-blue10 radix-state-unchecked:bg-slate6'
      )}
    >
      <Thumb className="pointer-events-none block h-5 w-5 rounded-full bg-slate2 shadow-lg ring-0 transition-transform radix-state-checked:translate-x-5 radix-state-unchecked:translate-x-0" />
    </Root>
  );
}

Switch.displayName = 'Switch';
